import { Box, Container, Typography } from '@mui/material';
import type { FC } from 'react';
import { useLocation } from 'react-router-dom';
import LeafioLogo from '~/assets/svgs/leafio-logo.svg';
import { Link } from '~/components/atoms/Link';
import { AccountMenu } from '~/components/molecules/AccountMenu';
import { HOME_PATH } from '~/constants';
import HeaderNavigation from '~/data/headerNavigation.json';

export const Header: FC = () => {
  const location = useLocation();
  return (
    <Box bgcolor="background.default" boxShadow="0px 4px 9px 0px rgba(0, 0, 0, 0.05)" data-testid="page-header">
      <Container>
        <Box
          display="grid"
          gridTemplateColumns={{ xs: '1fr', md: 'auto 1fr auto' }}
          alignItems={{ xs: 'center', md: 'unset' }}
          gap={{ md: 10.75 }}
        >
          {/* Logo */}
          <Link
            to={HOME_PATH}
            display="inline-block"
            py={1.5}
            width={140}
            sx={{ textDecoration: 'none' }}
            gridArea={{ xs: '1 / 1 / 2 / 2', md: '1 / 1 / 2 / 2' }}
            id="header_logo_link"
          >
            <Box
              component="img"
              src={LeafioLogo}
              alt="Leafio Supplier Portal"
              width="100%"
              sx={{ verticalAlign: 'bottom' }}
            />
          </Link>

          {/* Navigation */}
          <Box
            component="nav"
            display="flex"
            justifySelf="center"
            justifyContent={{ xs: 'space-between', md: 'flex-end' }}
            gridArea={{ xs: '2 / 1 / 2 / 3', md: '1 / 2 / 2 / 3' }}
            maxWidth={{ xs: 350, md: 'unset' }}
            width="100%"
            gap={{ md: 6.875 }}
          >
            {HeaderNavigation.items.map((item) => {
              const isActive = location.pathname.includes(item.url);
              const id = `header_nav_link_${item.label.toLowerCase().replaceAll(' ', '_')}`;
              return (
                <Typography
                  component={Link}
                  key={item.label}
                  id={id}
                  to={item.url}
                  typography={{ xs: 'subtitle2', md: 'body1' }}
                  display="inline-flex"
                  alignItems="center"
                  py={{ xs: 1.5 }}
                  px={{ xs: 0 }}
                  borderBottom="3px solid"
                  borderColor={isActive ? 'text.primary' : 'transparent'}
                  sx={(theme) => ({
                    color: theme.palette.text.primary,
                    textDecoration: 'none',
                  })}
                >
                  <Box component="span" fontWeight={isActive ? 'bold' : 'normal'}>
                    {item.label}
                  </Box>
                </Typography>
              );
            })}
          </Box>

          {/* Account menu */}
          <Box gridArea={{ xs: '1 / 2 / 2 / 2', md: '1 / 3 / 2 / 3' }} alignSelf={{ md: 'center' }}>
            <AccountMenu />
          </Box>
        </Box>
      </Container>
    </Box>
  );
};
